import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 数值输入事件类
 */

export default class EventValueInput extends EventBase {
  /**
   * 输入事件类实例的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '', '001:']
  }
  /**
   * 获取当前类的事件ID
   */
  Code = EventID.ValueInput
  /**
   * 设置或获取数值
   */
  get Value() {
    return parseInt(this.Parameter![0])
  }
  set Value(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 获取或设置数值名称
   */
  get ValueName() {
    return this.Parameter?.[1] ?? ''
  }
  set ValueName(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 获取或设置显示信息
   */
  get Content() {
    return this.Parameter?.[2] ?? ''
  }
  set Content(value) {
    this.Parameter![2] = value
  }

  /**
   * 获取显示信息
   */
  /// <returns></returns>
}
